import { AppState } from './types';
export const appState = {
    currentAppState: AppState.WRITE,
    currentProjectId: null,
    currentChatId: null,
    sanitizationPipeline: null,
    entityAnonymizer: null,
    entityContext: null,
    nerPipeline: null,
    isModelLoaded: false,
    uploadedFiles: [],
    currentEntityMaps: null,
    demoActive: false,
    demoTimeouts: [],
    defaultInputPlaceholder: 'Message BlindQuery...',
    availableModels: [],
    currentSystemPrompt: '',
    memoryEnabled: true,
    memoryScope: 'project',
    autoReviewEnabled: false
};
